export default __webpack_public_path__ + "static/media/ccash-round.0baf33ee.png";